import { useEffect, useState } from "react";
import { Form, Modal, Typography, Checkbox } from "antd";
import CustomSelect from "@/components/inputs/CustomSelect";

import { addMember } from "@/api/units";
import { getEmployeesOptions } from "@/api/employees";

const { Text } = Typography;

// Окно для добавления участника РГ
const MemberModal = ({ unit_uuid, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [employeeList, setEmployeeList] = useState([]);

  const fetchUserList = async () => {
    try {
      const { employees } = await getEmployeesOptions({ is_dismissed: false });

      setEmployeeList(
        employees.map((item) => {
          const { lastname, firstname, patronymic } = item.employee;
          return {
            ...item.employee,
            label: `${lastname || ""} ${firstname || ""} ${patronymic || ""}`,
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      await addMember({ ...values, unit_uuid });

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () =>
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });

  return (
    <Modal
      maskClosable={false}
      title="Добавление нового участника в рабочую группу"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Добавить"
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        initialValues={{ can_access_child_groups: false }}
        layout="vertical"
        onFinish={handleSave}
      >
        <Form.Item name="employee_uuid" label="Сотрудник">
          <CustomSelect
            placeholder="Начните вводить"
            options={employeeList}
            showSearch
            fieldNames={{ value: "uuid" }}
            optionFilterProp="label"
          />
        </Form.Item>

        <Form.Item name="can_access_child_groups" valuePropName="checked">
          <Checkbox>Доступ к дочерним группам</Checkbox>
        </Form.Item>

        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default MemberModal;
